import React, { useState } from 'react';
import Draggable from 'react-draggable';
import { useTheme } from '../contexts/ThemeContext';
import { Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const DraggablePopup = (props) => {
  const { theme } = useTheme();

  return (
    <div>
      <Draggable>
        <Box
          sx={{
            position: 'fixed',
            top: '100px',
            right: '100px',
            width: '408px',
            height: '765px',
            border: `1px solid ${theme.border.light}`,
            borderRadius: '10px',
            backgroundColor: 'rgba(230, 175, 10, 0.7)',
            cursor: "move",
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
            px: '10px',
            pt: '10px',
            zIndex: '1000',
          }}
        >
          <div style={{ marginBottom: '2vh' }}>
            <CloseIcon onClick={() => props.setWmitemId("")} style={{ padding: '5px 10px', cursor: 'pointer', color: theme.text.primary }} />
            <span style={{ float: "right", color: theme.text.primary }}>Click(Hold) and drag to move</span>
          </div>
          <iframe
            src={`https://app.getmarter.com/?walmartId=${props.itemId}&price=${props.price}`}
            title="Marter"
            style={{
              width: '100%',
              height: '700px',
              border: `1px solid ${theme.border.light}`,
              borderRadius: '6px',
            }}
          />
        </Box>
      </Draggable>
    </div>
  );
};

export default DraggablePopup;
